/* eslint-disable prettier/prettier */

import { withProps } from 'recompose';
import withFeature from './Feature';
import withVariation from './Variation';
import withModule from './ModuleFeature';

export const FEATURE = {
  STEP_METRICS: 'step-metrics'
};

// LaunchDarkly feature flags
export const withAppcues = withVariation('appcues', false);
// These flags were retired and now follow a fixed, offline-safe path.
export const withFieldExpressionValidation = withProps({
  fieldExpressionValidation: true
});
export const withInsightsDashboard = withProps({ insightsDashboard: true });
export const withIsEmptyConditions = withProps({ isEmptyConditions: true });
export const withLinksInTables = withProps({ linksInTables: true });
export const withModuleManagement = withProps({ moduleManagement: true });
export const withRunPermissions = withProps({ runPermissions: true });
export const withUserTokensUI = withProps({ userTokensUi: true });
export const withWebformTableClientSideFeatures = withProps({
  webformTableClientSideFeatures: true
});

// pushbot-api feature flags
export const withStepMetrics = withFeature(FEATURE.STEP_METRICS, false);
export const withTriggers = withFeature('triggers', false);

// module feature flags
// Do not provide a default value for `integrations` because we
// need to know definitively whether or not this is enabled or disabled.
export const withIntegrations = withModule('integrations');
export const withPredictiveModels = withModule('predictive-models', false);
export const withPredictThisField = withModule('predict-this-field', false);
// Do not provide a default value for `single-sign-on` because we
// need to know definitively whether or not this is enabled or disabled.
export const withSingleSignOn = withModule('single-sign-on');
